import { Loader } from '@components/loader';
import { AgreementOrders } from '@pages/agreements/orders';
import { useGetAgreement } from '@services/global/agreements/get';
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';
import { outletNavScroll } from '@utils/apiHelpers';
import { useEffect } from 'react';

function AgreementOrdersRoute() {
  const navigate = useNavigate();
  const { id, localId } = useParams({
    from: '/u/$localId/_merchant/merchant/agreements/$id/orders',
  });
  const { data, isPending } = useGetAgreement({ id });

  useEffect(() => {
    outletNavScroll();
  }, []);

  if (isPending) return <Loader />;
  if (!data) return null;

  return (
    <AgreementOrders
      orders={data.orders}
      onRowSelect={(orderId) => {
        navigate({ to: '/u/$localId/merchant/orders/$id', params: { id: orderId, localId } }).catch(
          (err) => console.error(err),
        );
      }}
    />
  );
}

export const Route = createFileRoute('/u/$localId/_merchant/merchant/agreements/$id/orders')({
  component: AgreementOrdersRoute,
});
